<p class="card-subtitle">
  outstanding information text
</p>